export function isLegacyRoute(): boolean {
  const legacyRoutes = ["/", "/bookcar", "/mytrips"];
  return legacyRoutes.includes(window.location.pathname.toLowerCase());
}
